enum GeneralPhaseNames {
    Start = 'Start',
    Prepare = 'Prepare',
    End = 'End',
};

export default GeneralPhaseNames;